import 'whatwg-fetch'
const env = process.env;

const formatDate = function(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

const getEventTypes = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/CalendarEventItems?access_token=${payload.apitoken}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
    })
}

const getEvents = (payload) => {
    
    let d = new Date();
    d.setDate(d.getDate() - 1);
    d = formatDate(d);

    let url = `${env.VUE_APP_trimaster}/api/v1/CalendarEvents?access_token=${payload.apitoken}&filter={"order" : "startdate asc", "where":{"facility_id":${payload.facilityId}, "enddate" : {"gt": "${d}"}}}`;
    return fetch(url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
}

const deleteEvent = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/CalendarEvents/${payload.id}?access_token=${payload.apitoken}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
    })
}

export default {
    getEventTypes,
    getEvents,
    deleteEvent
}
